<template>
    <div class="notiWrap" >
    <div class="navigatorWidget-title" @click="hiddenNoti()">
        <div class="navigatorWidget-title_wrap">
            <div class="navigatorWidget-title_text">СТРИМ</div>
            <div class="streamCount color-green">{{getEvents.length}}</div>
        </div>
            <i :class="show ? 'icon-icon-up': 'icon-icon-down'"></i>
    </div>
    <transition enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut" mode="out-in">
        <scrollbar :settings="settingsScroll" class="navigatorWidget-wrap" :style="'height:' + getHeightWidget + 'px'" id="notiBox" v-show="show">
            <stream-item  v-for="(item, index) in getEvents" :key="index"
                :data="item">
            </stream-item>
        </scrollbar>
    </transition>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import jQuery from "jquery";
const $ = jQuery;
window.$ = $;
import PositionsItem from './stream-itemPositions';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Switcher from '../../../ui-components/switcher';
import { setTimeout } from 'timers';
export default {
    data() {
        return {
            settingsScroll: {
                suppressScrollX:true
            },
            statusAuto:false,
            show:true,
            loading:true
        }
    },
    components: {
        'stream-item':PositionsItem,
        'scrollbar':VuePerfectScrollbar,
        'switcher':Switcher
    },
    computed: {
        ...mapGetters({
                getEvents:'accountevents/getStreamEvent',
            }),
        showWidget() {
            if(this.getEvents.length === 0)
                return true
        },
        getHeightWidget() {
            if(this.getEvents.length === 0)
                return 0;
            if(this.getEvents.length === 1)
                return 178;
            if(this.getEvents.length === 2)
                return 178;
            if(this.getEvents.length > 3)
                return 536;
        }
    },
    methods: {
        switchSelector(e) {
            this.statusAuto  = e;
            this.stopAuto(e);
        },
        hiddenNoti() {
            this.show = !this.show;
        }
    },
}
$.fn.verticalScroll = function() {
        function scroll($elem) {
            var padding = 1;
            if (!$elem.data("running")) {
                setTimeout(function() {
                    scroll($elem)
                }, 2400);
                return;
            }
            //  create a sorted list of sub divs
            var items = [];
            $('div#position', $elem).each(function(j, divdiv) {
                // if it's above the top, move the item to the bottom
                var top = parseInt($(divdiv).css("top"));
                if(top < 0) {
                    top = $elem.data("innerHeight") - (176 + padding*2);
                    $(divdiv).css("top", top);
                }
            items.push(divdiv);
            });
            items.sort(function(a, b) {return $(a).css("top") < $(b).css("top");});
            // shift each div by the height of the first (at the css top) item
            var shift = parseInt($(items[0]).css("height"));
            $(items).each(function(key, divdiv) {
                var top = parseInt($(this).css("top"));
                    $(divdiv).animate({ top: (parseInt(top) - shift - padding) }, 25 * shift);
                    //$(divdiv).css('top', 0);
            });
            // when all animations are done, start the next round
            $('div#position', $elem).promise().done(function() {
                scroll($elem);
            });
        }
        function destroy() {
        $el.each(function() {
                var el = this;
                var $el = $(this);
        $el.removeData('plugin_' + pluginName);
      });
    }
        $(this).each(function (i, div) {
          var padding = 1;
          var innerHeight = padding / 2;
          $(div).data("running", true);
          // TODO: maybe try to work on a fixed list of items instead of querying the dom
          // console.log('items', window.verticalScrol.items);
          // window.verticalScroll.items = [];
          $('div#position', div).each(function(j, divdiv) {
            $(this).css("top", innerHeight);
            innerHeight += parseInt($(this).css('height')) + padding;
          });
          $(div).data("innerHeight", innerHeight);
          scroll($(this));

          $(div).mouseenter(function($elem){
            $($elem.currentTarget).data("running", false);
          });
              
          $(div).mouseleave(function($elem){
            $($elem.currentTarget).data("running", true);
          });
        });
    return this;
};

</script>
<style lang="less" scoped>
#notiBox {
    position: relative;
    width:360px;
    height: 536px;
    overflow: auto;
}
.navigatorWidget {
    &-wrap {
        background: #293546;
        display: block;
        margin-bottom: 8px;
        //direction: rtl;
    }
    &-title {
        font-family: Arimo;
        font-size: 11px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        height: 40px;
        letter-spacing: 0.4px;
        color: #fff;
        padding: 0px 16px 0px 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #293546;
        //text-transform: uppercase;
        &_wrap {
            display: flex;
        }
        &_text {
            text-transform: uppercase;
        }
        i {
            font-size: 14px;
            color: #ADC4E1;
            cursor: pointer;
        }
    }
}
.streamCount {
    margin-left: 16px;
}
</style>

